import React from 'react';
import { UserAvatar } from '../../../shared/UserAvatar';
import {
    formatAuditActorLabel,
    formatAuditDate,
    formatAuditEntityLabel,
    getAuditActionLabel,
    getAuditActionTone,
    getAuditEntityTypeLabel,
} from '../helpers';

export const AuditLogTable = ({ auditLogs, isLoading, onOpenDetail }) => {
    if (isLoading) {
        return (
            <div className="audit-log-table-card">
                <div className="audit-log-table-skeleton">
                    {Array.from({ length: 6 }).map((_, index) => (
                        <div key={index} className="audit-log-table-skeleton__row" />
                    ))}
                </div>
            </div>
        );
    }

    if (!auditLogs.length) {
        return (
            <div className="audit-log-empty-state">
                <div className="audit-log-empty-state__icon">
                    <i className="feather-activity" />
                </div>
                <h5 className="mb-1">No hay movimientos para mostrar</h5>
                <p className="mb-0 text-muted">Ajusta los filtros o espera nuevas acciones dentro del tenant.</p>
            </div>
        );
    }

    return (
        <div className="table-responsive audit-log-table-card">
            <table className="table mb-0 align-middle audit-log-table">
                <thead>
                    <tr>
                        <th>Fecha</th>
                        <th>Actor</th>
                        <th>Acción</th>
                        <th>Entidad</th>
                        <th>Resumen</th>
                        <th className="text-end">Detalle</th>
                    </tr>
                </thead>
                <tbody>
                    {auditLogs.map((auditLog) => (
                        <tr key={auditLog._id}>
                            <td>
                                <div className="fw-semibold">{formatAuditDate(auditLog.createdDate)}</div>
                            </td>
                            <td>
                                <div className="audit-log-actor-cell">
                                    <UserAvatar
                                        name={formatAuditActorLabel(auditLog)}
                                        photoUrl={auditLog?.actorUser?.photoUrl}
                                        className="audit-log-actor-avatar"
                                        fallbackClassName="audit-log-actor-avatar audit-log-actor-avatar--fallback"
                                    />
                                    <div>
                                        <div className="fw-semibold">{formatAuditActorLabel(auditLog)}</div>
                                        <div className="text-muted fs-12">{auditLog?.actorUser?.email || auditLog?.actorEmail || 'Sin email'}</div>
                                    </div>
                                </div>
                            </td>
                            <td>
                                <span className={`audit-log-badge audit-log-badge--${getAuditActionTone(auditLog.action)}`}>
                                    {getAuditActionLabel(auditLog.action)}
                                </span>
                            </td>
                            <td>
                                <div className="fw-semibold">{getAuditEntityTypeLabel(auditLog.entityType)}</div>
                                <div className="text-muted fs-12">{formatAuditEntityLabel(auditLog)}</div>
                            </td>
                            <td>
                                <div className="audit-log-summary">{auditLog.summary || 'Sin resumen'}</div>
                            </td>
                            <td className="text-end">
                                <button type="button" className="btn btn-light-brand btn-sm" onClick={() => onOpenDetail(auditLog)}>
                                    Ver detalle
                                </button>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};